import React from 'react';
import styled, { css } from 'styled-components';
import { HasChildren, PageLayoutComponent, Slice } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SlicesRenderer, Std } from '@shapeable/ui';


// -------- Styles -------->


const LayoutStyles = breakpoints({
  base: css`
  `,
  tablet: css`
  `,
  desktop: css`
  `
});

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});



// -------- Components -------->

const My = {
  Container: styled.div<Std.Props>`${ContainerStyles}`,
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity } = props;

  return (
    <My.Container className={className}>
      <SlicesRenderer items={entity.slices} />
    </My.Container>
  )
};
